export default __webpack_public_path__ + "static/media/Oppo_Reno_5F.16b9feb0.jpg";